var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "120px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "第三方网页名称", prop: "name" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: { maxlength: "255" },
                model: {
                  value: _vm.childData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "name", $$v)
                  },
                  expression: "childData.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "网页地址", prop: "url" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: { maxlength: "255" },
                model: {
                  value: _vm.childData.url,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "url", $$v)
                  },
                  expression: "childData.url"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "网页描述" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  type: "textarea",
                  maxlength: "255",
                  autosize: { minRows: 3, maxRows: 3 }
                },
                model: {
                  value: _vm.childData.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "remark", $$v)
                  },
                  expression: "childData.remark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }